{
  "drawer": {
    "title": "Ghi nhận thanh toán",
    "subtitle": {
      "invoice": "Ghi nhận thu tiền cho hoá đơn {{code}}",
      "adhoc": "Ghi nhận một khoản doanh thu không gắn hoá đơn"
    },
    "field": {
      "amount": "Số tiền *",
      "amountPlaceholder": "Vd: 2.000.000",
      "date": "Ngày *",
      "source": "Nguồn *",
      "content": "Ghi chú",
      "contentPlaceholder": {
        "CASH": "Vd: Khách Hùng trả tay",
        "MANUAL_BANK": "Vd: Chuyển khoản từ tài khoản phụ",
        "ECOMMERCE": "Vd: Shopee đơn #123 / Lazada payout 2026-05",
        "OTHER": "Mô tả ngắn..."
      },
      "client": "Khách hàng",
      "noClient": "(Không gắn khách)"
    },
    "source": {
      "CASH": "Tiền mặt",
      "MANUAL_BANK": "Chuyển khoản ngoài",
      "ECOMMERCE": "Sàn TMĐT",
      "OTHER": "Khác"
    },
    "cancel": "Huỷ",
    "save": "Lưu",
    "saving": "Đang lưu..."
  },
  "toast": {
    "paid": "Hoá đơn đã được thanh toán đầy đủ",
    "partial": "Đã ghi nhận thanh toán một phần",
    "adhoc": "Đã ghi nhận doanh thu",
    "deleted": "Đã xoá thanh toán",
    "error": "Có lỗi xảy ra, thử lại"
  },
  "inbox": {
    "title": "Giao dịch chưa khớp",
    "subtitle": "Các khoản chuyển khoản chưa gán được vào hoá đơn nào, gán thủ công vào hoá đơn hoặc bỏ qua.",
    "consequence": "Chuyển khoản đúng nội dung QR sẽ tự khớp; khoản nào lệch mới rơi vào đây.",
    "loading": "Đang tải...",
    "loadError": "Không tải được danh sách giao dịch",
    "empty": "Không có giao dịch chưa khớp",
    "emptyBody": "Mọi chuyển khoản đã được gán vào hoá đơn.",
    "column": {
      "amount": "Số tiền",
      "content": "Nội dung chuyển khoản",
      "date": "Ngày",
      "confidence": "Trạng thái khớp",
      "actions": "Thao tác"
    },
    "confidence": {
      "needs_confirmation": "Nghi ngờ trùng số tiền",
      "unmatched": "Chưa xác định được hoá đơn"
    },
    "action": {
      "link": "Gán vào hoá đơn",
      "ignore": "Bỏ qua",
      "more": "Thao tác khác"
    },
    "linkDialog": {
      "title": "Gán vào hoá đơn",
      "description": "Chọn hoá đơn còn nợ để gán khoản {{amount}} này vào.",
      "select": "Chọn hoá đơn...",
      "unknownClient": "Không rõ khách hàng",
      "empty": "Không có hoá đơn nào đang chờ thanh toán hoặc trả một phần",
      "cancel": "Huỷ",
      "confirm": "Gán"
    },
    "ignoreDialog": {
      "title": "Bỏ qua giao dịch này?",
      "description": "Giao dịch sẽ bị loại khỏi doanh thu và sổ thu chi, và không còn hiển thị trong danh sách chưa khớp. Dùng khi đây không phải tiền học phí.",
      "cancel": "Huỷ",
      "confirm": "Bỏ qua"
    },
    "toast": {
      "linked": "Đã gán giao dịch vào hoá đơn",
      "ignored": "Đã bỏ qua giao dịch"
    },
    "navLink": "Giao dịch chưa khớp"
  }
}
